/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { tagContentTypeEnumSchema } from "./tagContentTypeEnumSchema.ts";
import { z } from "zod";

export const tagModelSchema = z.object({
    "id": z.number().int().describe("Идентификатор жанра"),
"name": z.string().describe("Наименование"),
"contentType": z.lazy(() => tagContentTypeEnumSchema).describe("Типы контента, на который распространяются жанры<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Book</b>: Книга</li>\n<li><b>4 - Album</b>: Альбом</li>\n<li><b>5 - Mood</b>: Настроение</li>\n</ul>\n")
    })